<div class="nf-wrap">
  <div class="nf-card">
    <div class="nf-graphic" aria-hidden="true">
      <!-- Minimal inline SVG illustration -->
      <svg viewBox="0 0 120 60" role="img">
        <defs>
          <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#6366f1" />
            <stop offset="100%" stop-color="#22d3ee" />
          </linearGradient>
        </defs>
        <circle cx="25" cy="30" r="18" fill="url(#g)" opacity="0.25"/>
        <rect x="50" y="18" width="54" height="24" rx="6" fill="url(#g)" opacity="0.18"/>
      </svg>
    </div>

    <h1 class="nf-title">
      <span class="nf-404">404</span>
      <span class="nf-divider" aria-hidden="true">•</span>
      Not found
    </h1>

    <p class="nf-text">
      The page you’re looking for doesn’t exist or has been moved.
    </p>

    <!-- <div class="nf-actions">
      <button class="btn primary" (click)="goHome()">Go home</button>
      <button class="btn ghost" (click)="goBack()">Go back</button>
    </div> -->

    <!-- <a class="nf-link" href="mailto:support@example.com?subject=Broken%20link">
      Report a broken link
    </a> -->
  </div>
</div>